import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['message-abstract-file-left'])
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass(['message-abstract-file-main'])
};
var _hoisted_4 = {
  class: /*@__PURE__*/_normalizeClass(['message-abstract-file-main-name'])
};
var _hoisted_5 = {
  class: /*@__PURE__*/_normalizeClass(['message-abstract-file-main-size'])
};
import { ref, computed } from '../../../../../adapter-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-file',
  props: {
    contentText: {
      default: () => []
    },
    messageContent: {
      default: () => ({})
    },
    displayType: {
      default: 'bubble'
    }
  },
  setup(__props) {
    var props = __props;
    var contentText = ref(props.contentText);
    var typeIcon = computed(() => {
      var _props$messageContent;
      var fileUrl = props === null || props === void 0 || (_props$messageContent = props.messageContent) === null || _props$messageContent === void 0 ? void 0 : _props$messageContent.url;
      var index = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.lastIndexOf('.');
      var type = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.substring(index + 1);
      return handleFileIconForShow(type);
    });
    var fileSize = computed(() => {
      var _props$messageContent2;
      return props === null || props === void 0 || (_props$messageContent2 = props.messageContent) === null || _props$messageContent2 === void 0 ? void 0 : _props$messageContent2.size;
    });
    var handleFileIconForShow = type => {
      var urlBase = 'https://web.sdk.qcloud.com/component/TUIKit/assets/file-';
      var fileTypes = ['image', 'pdf', 'text', 'ppt', 'presentation', 'sheet', 'zip', 'word', 'video', 'unknown'];
      var url = '';
      var iconType = '';
      fileTypes === null || fileTypes === void 0 || fileTypes.forEach(typeName => {
        if (type !== null && type !== void 0 && type.includes(typeName)) {
          url = urlBase + typeName + '.svg';
          iconType = typeName;
        }
      });
      return {
        iconSrc: url || urlBase + 'unknown.svg',
        iconType: iconType || 'unknown'
      };
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['message-abstract-file', "message-abstract-file-".concat(_ctx.displayType)])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        class: _normalizeClass(['message-abstract-file-left-icon']),
        src: _unref(typeIcon).iconSrc
      }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentText), (contentItem, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(contentItem.text), 3);
      }), 128))]), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(fileSize)), 1)])], 2);
    };
  }
});